// An update that brings the document's structure up to date with the note:
// only these add, move or remove its sections, lines and blocks.
export const NOTE_STRUCTURE_TAG = 'note-structure';

// An update that deletes a selection across the note's texts, values and
// lines: the note takes what went, and the document waits for it.
export const NOTE_DELETION_TAG = 'note-deletion';
